<template>
  <span class="symbolIcon" :class=iconName :style="styleObject" @click="onClicked">
    <QuestTypeMoreLogo v-if="iconName === questTypeEnum.more"/>
    <QuestTypeSmartLogo v-else-if="iconName === questTypeEnum.smart"/>
    <QuestTypeTogetherLogo v-else-if="iconName === questTypeEnum.together"/>
    <QuestTypeImpulseLogo v-else-if="iconName === questTypeEnum.impulse"/>
    
      <span class="hover-info">
        <span class="content">
          <p>{{ hoverName }}</p>
        </span>
      </span>
  </span>

</template>

<script>
import QuestTypeMoreLogo from "@/assets/image/icons/quest/icon-activity_beweeg_meer.svg?inline";
import QuestTypeSmartLogo from "@/assets/image/icons/quest/icon-activity_beweeg_slim.svg?inline";
import QuestTypeTogetherLogo from "@/assets/image/icons/quest/icon-activity_beweeg_samen.svg?inline";
import QuestTypeImpulseLogo from "@/assets/image/icons/quest/icon-activity_beweeg_tussendoor.svg?inline";
import {QuestTypeEnum} from "sandpiper_api";


export default {
  name: "SymbolIcon",
  components: {QuestTypeImpulseLogo, QuestTypeSmartLogo, QuestTypeMoreLogo, QuestTypeTogetherLogo},
  data() {
    return {
      styleObject: {
        fontSize: this.iconSize,
        fill: this.color
      },
      questTypeEnum: new QuestTypeEnum()
    };
  },
  props: {
    color: {
      type: String,
      default: "black"
    },
    hoverName: {
      type: String,
      default: "Icon"
    },
    iconName: String,
    iconSize: {
      type: String,
      default: "1rem"
    }
  },
  computed: {},
  methods: {
    onClicked() {
      this.$emit("clicked");
    }
  }
}
</script>

<style lang="scss" scoped>
.symbolIcon {
  &:hover {
    .hover-info {
      visibility: visible;
    }
  }

  .hover-info {
    visibility: hidden;
  }
}

.hover-info {
  position: relative;
  left: 0;
  top: 0;
  z-index: 999;

  .content {
    position: absolute;
    left: 0;
    top: -100;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    box-shadow: $default-shadow;
    min-width: 100px;
    text-align: center;
    cursor: auto;

    p {
      margin-bottom: 0;
      cursor: auto;
    }
  }
}
</style>